import React, { useEffect, useState, useRef } from "react";
import { useUiState } from "./../../../helpers/useUiState";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import BgImage from "assets/img/bg-image.png";
import { Button, Form, Grid, Input, theme, Typography, Select } from "antd";
import { useAuthProvider } from "./../../Auth/hooks/useAuthProvider";
import { useAuthSrv } from "pages/Auth/hooks/useAuthSrv";
import {
  setLocalStore,
  getLocalStore,
  removeLocalStore,
} from "helpers/localStoreSrv";
import { InputOTP } from "antd-input-otp";
import i18n from "i18next";

import whitelabelConfig from "@whitelabel-config";

import { useTranslation } from "react-i18next";
import { Alert, Space } from "antd";

import otpConfig from "../meta_config.json";
import { portalActions } from "store/portal-slice";
import AppLogo from "./../../../components/AppLogo/AppLogo";
import BrandColors from "@brand-colors";
import { LANGUAGES } from "../../../constants/supported_lang";
import "./Auth.css";
import ReactGA from "react-ga";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import OtpInput from "./OtpInput";
const { Option } = Select;
type ErrorState = {
  isError: boolean;
  errMsg: string;
};

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text } = Typography;
const initialErrorState: ErrorState = {
  isError: false,
  errMsg: "",
};
const AuthPage = () => {
  const portalSessionMeta = useSelector(
    (state: any) => state.portal.micrositeSession
  );
  const portalAuthSessionMeta = useSelector(
    (state: any) => state.portal.authSession
  );
  const { isAppLoading } = useUiState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otpValues, setOtpValues] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOtpError, setIsOtpError] = useState(initialErrorState);
  const [selectedLanguage, setSelectedLanguage] = useState("en"); // Default to English
  const surveyLanguage = useSelector(
    (state: any) => state.portal.uiState.SurveyLanguage
  );
  console.log("surveyLanguage", surveyLanguage);
  const [selectedLanguageForDropdown, setselectedLanguageForDropdown] =
    useState(surveyLanguage || "en");
  const [isRightAlign, setIsRightAlign] = useState(false);
  const { state } = useLocation();
  const { authStep } = state;
  const { generate2faOTP, verifyOTP, generateEmailPhoneOTP } = useAuthSrv();
  const { updateAuthSession, updateAuthWizard } = useAuthProvider();
  const { token } = useToken();
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const [isHover, setIsHover] = useState(false);
  const [authFlow, setAuthFlow] = useState(whitelabelConfig.authFlow);
  const currAuthFlow = authFlow["DEFAULT"];
  const inputRef = useRef<HTMLInputElement>(null);
  const [otp, setOtp] = useState("");
  const onChange = (value: string) => setOtp(value);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  useEffect(() => {
    dispatch(portalActions.updateAuthWizard(currAuthFlow));
  }, []);
  useEffect(() => {
    if (surveyLanguage) {
      setselectedLanguageForDropdown(surveyLanguage);
    }
  }, [surveyLanguage]);

  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          surveyLanguage
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
    }
  }, [isRightAlign, surveyLanguage]);

  useEffect(() => {
    if (selectedLanguageForDropdown) {
      setSelectedLanguage(selectedLanguageForDropdown);
      setselectedLanguageForDropdown(selectedLanguageForDropdown);
    }
  }, [selectedLanguageForDropdown]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener("input", (event) => {
        const value = (event.target as HTMLInputElement).value;
        console.log("Autofill OTP:", value);

        if (value.length === otpConfig.AUTH2FA_OTPLENGTH) {
          form.setFieldsValue({ otp: value.split("") });
        }
      });
    }
  }, []);

  const styles = {
    container: {
      margin: "0 auto",
      maxWidth: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
      textAlign: isRightAlign ? "right" : "",
    },
    mainheader: {
      height: "80px",
      padding:
        whitelabelConfig.uiSettings.logoHeightFull === true ? "0 0" : "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
      borderTop: "1px solid #cccccc",
    },
    subheaderinner: {
      maxWidth: "85%",
      padding: "20px 0 15px 0",
      margin: "0 auto",
      fontWeight: "600",
      textAlign: isRightAlign ? "right" : "",
    },
    section: {
      alignItems: "center",
      backgroundSize: "cover",
      display: "flex",
      padding: screens.md ? `${token.sizeXXL}px 0px` : "0px",
      height: "100vh",
    },
    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
    },
    footertext: {
      color: "#333",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "21px",
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
    bodycontainer: {
      maxWidth: "85%",
      margin: "0 auto",
      paddingBottom: "20px",
      textAlign: isRightAlign ? "right" : "",
    },
    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      borderRadius: "50px",
      textTransform: "uppercase",
      fontWeight: "500",
      boxShadow: "none",
    },
    containwrapper: {
      padding: "0 15px",
      display: "flex",
      width: "100%",
    },
  };
  const validateEmail = (loginEmail: string) => {
    let regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!loginEmail || loginEmail.length == 0) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_MAIL_VALIDATION1")}`,
      });
      return false;
    } else if (!regex.test(String(loginEmail).toLowerCase())) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_MAIL_VALIDATION2")}`,
      });
      return false;
    } else {
      return true;
    }
  };
  const validatePhone = (loginPhone: string) => {
    let regex = /^[0-9]{10}$/;
    if (!loginPhone || loginPhone.length == 0) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_PHONE_VALIDATION1")}`,
      });
      return false;
    } else if (!regex.test(String(loginPhone).toLowerCase())) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("LOGIN_PHONE_VALIDATION2")}`,
      });
      return false;
    } else {
      return true;
    }
  };
  const verifyAuthMode = (loginId: string) => {
    let authMode = identifyAuthMode(loginId);
    let isValid = true;
    if (
      (authMode == "email" && !validateEmail(loginId)) ||
      (authMode == "mobile" && !validatePhone(loginId))
    ) {
      isValid = false;
    }
    return isValid ? authMode : null;
  };
  const identifyAuthMode = (loginId: string) => {
    var emailRegex = /\S+@\S+\.\S+/;
    var phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    if (emailRegex.test(loginId)) {
      return "email";
    } else if (phoneRegex.test(loginId)) {
      return "mobile";
    } else {
      return false;
    }
  };
  const [form] = Form.useForm();
  const handleStep1 = (values: any) => {
    setIsOtpError(initialErrorState);
    let authMode = verifyAuthMode(values.email_phone);
    if (
      !values.email_phone ||
      values.email_phone == undefined ||
      values.email_phone == "" ||
      authMode == null
    ) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("AUTH2FA.ERRSTART")} ${t("AUTH2FA.ERR_NULL_EMAIL_PHONE")}`,
      });
      return;
    } else {
      isAppLoading(true);
      generateEmailPhoneOTP(values.email_phone, `${authMode}/authenticate/`)
        ?.then((res: any) => {
          console.log("res++++++", res);
          const authSession = {
            auth_progress: "PROGRESS",
            user_id: values.email_phone,
          };
          updateAuthSession(authSession);
          handleGenerateOtpRes(res);
        })
        .catch((e) => {
          setIsOtpError({
            isError: true,
            errMsg: `${t("AUTH2FA.ERRSTART")} ${t(
              "AUTH2FA.ERR_NULL_EMAIL_PHONE"
            )}`,
          });
          form.resetFields(["email_phone"]);
        });
    }
  };
  const handleGenerateOtpRes = (res: any) => {
    console.log("res?.data.Language", res?.data.Language);
    const isDisabled = res?.data?.SurveyLanguage !== 0;
    console.log("isDisabled", isDisabled);
    setIsDisabled(isDisabled);
    isAppLoading(false);
    const languageId = res.data?.SurveyLanguage;
    const language = LANGUAGES.find((lang) => lang.id === languageId);
    const memberLanguageId = res?.data.Language;
    const memberLanguage = LANGUAGES.find(
      (lang) => lang.id === memberLanguageId
    );
    ReactGA.event({
      category: "Verify OTP ",
      action: "Success API Validation ",
      label: "Auth 2fa Page",
    });

    if (language) {
      i18n.changeLanguage(language.code);
      dispatch(portalActions.updateLanguageState(language.code));
      dispatch(portalActions.updateSurveyLanguageState(language.code));
    } else if (memberLanguage) {
      i18n.changeLanguage(memberLanguage.code);
      dispatch(portalActions.updateLanguageState(memberLanguage.code));
      dispatch(portalActions.updateSurveyLanguageState(memberLanguage.code));
    }
    let uiPayloadAgreement = {
      contentTitle: t("AGREEMENT_GLOBAL.TITLE"),
      contentText: t("AGREEMENT_GLOBAL.AGREEMENT_TEXT", {
        PRODUCT_NAME: process.env.REACT_APP_PRODUCT,
      }),
      isCompleted: false,
    };
    if (res.data.SurveyLabel?.AgreementText) {
      uiPayloadAgreement = {
        contentTitle: res.data.SurveyLabel.Title,
        contentText: res.data.SurveyLabel.AgreementText,
        isCompleted: false,
      };
    }

    dispatch(portalActions.updateAgreementState(uiPayloadAgreement));
    let uiPayloadThankyou = {
      contentTitle: t("THANKYOU.TITLE"),
      contentText: t("THANKYOU.CONTENT_TEXT", {
        PRODUCT_NAME: process.env.REACT_APP_PRODUCT,
      }),
      isCompleted: false,
    };
    if (res.data.SurveyLabel?.ConfirmationText) {
      uiPayloadThankyou = {
        contentTitle: res.data.SurveyLabel.Title,
        contentText: res.data.SurveyLabel.ConfirmationText,
        isCompleted: false,
      };
    }
    dispatch(portalActions.updateThankYouState(uiPayloadThankyou));
    if (res.data.Appointment) {
      let appointmentState = {
        contentText: res.data.Appointment.AppointmentText,
        contentRef: res.data.Appointment.ContactCenterNumber,
      };
      dispatch(
        portalActions.updateAppointmentCallforwardState(appointmentState)
      );
    }
    setLocalStore("2FA_TOKEN", res.data.TokenID);
  };
  const handleFinish = (values: any) => {
    console.log("values....................", values.otp);
    let otp = values.otp.split("");
    setIsOtpError(initialErrorState);
    if (
      !otp ||
      otp.includes(undefined) ||
      otp.includes("") ||
      otp.length !== otpConfig.AUTH2FA_OTPLENGTH
    ) {
      setIsOtpError({
        isError: true,
        errMsg: `${t("AUTH2FA.ERRSTART")} ${otpConfig.AUTH2FA_OTPLENGTH} ${t(
          "AUTH2FA.ERREND"
        )}`,
      });
      setOtpValues([]);
      return;
    }

    isAppLoading(true);
    let authMode = identifyAuthMode(portalAuthSessionMeta.user_id);
    verifyOTP(
      getLocalStore("2FA_TOKEN"),
      values.otp,
      authMode,
      portalAuthSessionMeta.user_id
    )
      ?.then((res: any) => {
        console.log("res_____", res);
        isAppLoading(false);
        if (res.data.Authenticated === "true") {
          const authSession = {
            auth_progress: "PROGRESS",
            access_token: res.data.Access_Token,
            user_name: res.data.MemberName,
          };
          updateAuthSession(authSession);
          if (res.data.PendingSurveys && res.data.PendingSurveys.length > 0) {
            const sessionPayload = {
              pendingSurveys: res.data.PendingSurveys,
            };
            dispatch(portalActions.updateMicrositeSession(sessionPayload));
          }
          updateAuthWizard(authStep.onSuccess);
          ReactGA.event({
            category: "Verify OTP Button Click",
            action: "Success OTP JS Vaidation",
            label: "Auth 2fa Page",
          });
          setIsOtpError(initialErrorState);
        } else {
          ReactGA.event({
            category: "Verify OTP Button Click",
            action: "Failed OTP JS Validation ",
            label: "Auth 2fa Page",
          });
          setIsOtpError({
            isError: true,
            errMsg: `${t("AUTH2FA.NUMBEROFATTEMPTSSTARTMSG")} ${
              res?.data?.AttemptsRemaining
            } ${t("AUTH2FA.NUMBEROFATTEMPTSENDMSG")}`,
          });
          form.resetFields(["otp"]);
          setOtpValues([]);
        }
      })
      .catch((e) => {
        console.log("catch", e);
        removeLocalStore("2FA_TOKEN");
        form.resetFields(["otp"]);
        handleErrorNavigation(e, navigate, t);
      });
  };
  const step2 = () => {
    isAppLoading(true);
    generate2faOTP()
      ?.then((res: any) => {
        console.log("res.....", res);
        handleGenerateOtpRes(res);
      })
      .catch((e) => {
        console.log("coming..", e);
        ReactGA.event({
          category: "Verify OTP ",
          action: "Failed API Validation ",
          label: "Auth 2fa Page",
        });
        handleErrorNavigation(e, navigate, t);
      });
  };
  const step1 = () => {
    if (
      portalAuthSessionMeta.user_id?.length > 0 &&
      portalAuthSessionMeta.auth_progress == "NOT-STARTED"
    ) {
      handleStep1({ email_phone: portalAuthSessionMeta.user_id });
    }
  };
  const handleLanguageChange = (value) => {
    setSelectedLanguage(value);
    setselectedLanguageForDropdown(value);
    localStorage.setItem("preferredLanguage", value);
    i18n.changeLanguage(value); // Update i18n language
    dispatch(portalActions.updateLanguageState(value));
    dispatch(portalActions.updateSurveyLanguageState(value));
    i18n.changeLanguage(value);
  };
  const handlePaste = (event: any) => {
    const pastedData = event.clipboardData.getData("text");
    console.log("pastedData................", pastedData);
    if (pastedData.length === otpConfig.AUTH2FA_OTPLENGTH) {
      const otpArray = pastedData.split("");
      form.setFieldsValue({ otp: otpArray });
    }
  };
  console.log("isDisabled", isDisabled);
  useEffect(() => {
    sessionStorage.clear();
    if (portalSessionMeta.urlRef) {
      step2();
    } else {
      step1();
    }
  }, []);
  return (
    <section style={styles.section} data-testid="auth-fa">
      <img
        src={BgImage}
        style={{
          objectFit: "cover",
          position: "absolute",
          maxWidth: "100%",
          height: "100vh",
          zIndex: 0,
          width: "100%",
        }}
      />
      <div style={styles.containwrapper}>
        <div style={styles.container}>
          <div style={styles.mainheader} className="logo-header">
            <AppLogo />
          </div>
          <div style={styles.header}>
            <Text style={styles.text}>
              {t("AUTH2FA.DESCRIPTION", {
                HELPPHONE: process.env.REACT_APP_HELP_PHONE,
              })}
            </Text>
          </div>
          {whitelabelConfig.uiSettings.isLandingImage && (
            <img
              src={`${whitelabelConfig.uiSettings.landingImageUrl}`}
              style={{ paddingBottom: "10px" }}
            />
          )}
          <div style={styles.subheader}>
            <div style={styles.subheaderinner}>
              {portalSessionMeta.urlRef && (
                <>
                  <p style={styles.text}>
                    {t("AUTH2FA.SURVEY_LANGUAGE_SELECTION_TEXT")}
                  </p>
                  <Select
                    value={selectedLanguage}
                    onChange={handleLanguageChange}
                    style={{
                      width: "100%",
                      marginBottom: 20,
                      color: "#333",
                      fontSize: "12px",
                      lineHeight: "21px",
                      textAlign: "center",
                    }}
                    disabled={isDisabled}
                  >
                    {LANGUAGES.map((lang) => (
                      <Option
                        key={lang.code}
                        value={lang.code}
                        style={styles.text}
                      >
                        {lang.label}
                      </Option>
                    ))}
                  </Select>
                </>
              )}
              {(portalSessionMeta.urlRef || portalAuthSessionMeta.user_id) && (
                <Text style={styles.text}>{t("AUTH2FA.WELCOME_TEXT")}</Text>
              )}
              {!portalSessionMeta.urlRef && !portalAuthSessionMeta.user_id && (
                <Text style={styles.text}>{t("AUTH2FA.LABEL_EMAIL")}</Text>
              )}
            </div>
          </div>
          <div style={styles.bodycontainer}>
            {(portalSessionMeta.urlRef || portalAuthSessionMeta.user_id) && (
              <Form
                onFinish={handleFinish}
                form={form}
                initialValues={{ otp: "" }} // Initialize with empty value
              >
                <Form.Item name="otp" style={{ marginBottom: "20px" }}>
                  <OtpInput
                    value={otp}
                    valueLength={6}
                    onChange={(value: any) => {
                      onChange(value);
                      if (value.length === 6) {
                        form.submit(); // Automatically submits the form
                      }
                    }}
                  />
                </Form.Item>

                {isOtpError.isError === true ? (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Alert message={isOtpError.errMsg} type="error" />
                  </Space>
                ) : null}

                <Form.Item style={{ marginBottom: "20px" }}>
                  <Button
                    block={true}
                    type="primary"
                    htmlType="submit"
                    style={styles.button}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => {
                      // Force form to submit regardless of OTP state
                      setTimeout(() => {
                        form.submit();
                      }, 0);
                    }}
                  >
                    {t("AUTH2FA.LOGIN")}
                  </Button>
                </Form.Item>

                <Text style={styles.footertext}>{t("AUTH2FA.FOOTER")}</Text>
              </Form>
            )}
            {!portalSessionMeta.urlRef && !portalAuthSessionMeta.user_id && (
              <Form onFinish={handleStep1} form={form}>
                <Form.Item name="email_phone" style={{ marginBottom: "20px" }}>
                  <Input
                    style={{ height: "42px", width: "100%", fontSize: "14px" }}
                  />
                </Form.Item>
                {isOtpError.isError === true ? (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    <Alert message={isOtpError.errMsg} type="error" />
                  </Space>
                ) : null}
                <Form.Item style={{ marginBottom: "20px" }}>
                  <Button
                    block={true}
                    type="primary"
                    htmlType="submit"
                    style={styles.button}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    {portalSessionMeta.urlRef && t("AUTH2FA.LOGIN")}
                    {!portalSessionMeta.urlRef && t("AUTH2FA.SEND_CODE")}
                  </Button>
                </Form.Item>
                <Text style={styles.footertext}>{t("AUTH2FA.FOOTER")}</Text>
              </Form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default AuthPage;
